const $ = require('jquery');
let $form = $('.ferry-form');
let $ferry_container = $('.ferry-results');
let $table_container = $('.ferry-table');
let $button = $('.ferry-form-button');

if ($form.length) {
    let $datepicker = $form.find('.datepicker');

    new Pikaday({
        format: 'DD-MM-YYYY',
        field: $datepicker[0],
        firstDay: 1,
        minDate: new Date(),
        setDefaultDate: true,
        i18n: pikaday_i18n,
    });

    $form.on('submit', (e) => {
        e.preventDefault();
        submitFerryForm();
    });

    $form.on('change', (e) => {
        submitFerryForm();
    });

    $button.on('click', () => {
        submitFerryForm();
    })
}

let submitFerryForm = () => {
    $ferry_container.addClass('is-loading');

    let data = $form.serialize();
    let url = dbk_ferry.rest_api_url + '&' + data;

    $.get(url, (response) => {
        $table_container.html(response);

        $ferry_container.removeClass('is-loading');
    });
}